import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-header-alt',
    templateUrl: './header-alt.component.html',
    styleUrl: './header-alt.component.scss',
    standalone: false
})
export class HeaderAltComponent {
  @Input() title: string | undefined;
  @Input() isSemiBold: boolean = false;
}
